"use client"

import { ContactHero } from "@/features/client/sections/Contact/CHero"
import { ContactInformation } from "@/features/client/sections/Contact/ContactPageInfo-dynamic"
import { ContactFormSection } from "@/features/client/sections/Contact/ContactForm"
import { LocationMap } from "@/features/client/sections/Contact/Address"

const Contact = () => {
  return (
    <main className="min-h-screen bg-white">
      <ContactHero />
      <ContactFormSection />
      <ContactInformation />
      <LocationMap />
    </main>
  )
}

export default Contact
